import { useEffect, useRef } from 'react';

export function useInitialRender(callback: () => any, dependencies: []) {
  const firstRenderRef = useRef(true);

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return callback();
    } else return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies]);
}

export function useNoInitialRender(callback: () => any, dependencies: []) {
  const firstRenderRef = useRef(true);

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
    } else callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...dependencies]);
}
